<template>
    <div class="details-table-all-1" :ref="config.title + '_' + '3'">
        <div class="header">
            <div class="details-table-row table-col-nowrap" :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 3}">
                <div class="details-table-header-row text-center" style="min-width: 45px;width:45px;">序号</div>
            </div>
            <template v-for="(list, index) in config.list" :key="list.title + '-' + index">
                <table-header-col>
                    <div
                        class="details-table-header-row details-width"
                        :style="'width:' + (list.width === '100%' || !list.width ? '180px' : list.width)">
                    <i class="cor-red" v-if="list.required === 'required'">*</i>
                    <div class="one-omit" :title="list.name">
                        <el-tooltip v-if="list.annotationTop || list.annotationBottom" effect="light" placement="top">
                            <template #content>
                                <div>{{ list.annotationTop }}<br/>{{ list.annotationBottom }}</div>
                            </template>
                            <span style="cursor:pointer;">{{list.name}}</span>
                        </el-tooltip>
                        <template v-else>
                            {{list.name}}
                        </template>
                    </div>
                    </div>
                    <span class="table-mouse" @mousedown="addMousedown($event, list.title + '_' + list.type)"></span>
                </table-header-col>
            </template>
        </div>
        <el-scrollbar style="padding-bottom: 20px;"
               :style="{width: tableWidth+'px'}"
               :scrollHStyle="'transform: translateX(-' + Math.abs(parseInt(tableWidth - tableCellWidth - topDistance)) + 'px)'">
               <div class="details-table-no-text" :style="'width:' + tableWidth + 'px;'" v-if="formdata.data.length === 0">
                    <div>暂无数据</div>
                </div>
                <template v-else>
                    <template v-for="(lists, listsIndex) in formdata && formdata.data ? formdata.data : []" :key="config.title + listsIndex">
                        <div class="details-table-col fixed-value">
                            <div class="details-table-row table-col-nowrap" :style="{ transform: 'translate3d(' + topDistance + 'px,0,0)', zIndex: 3}">
                                <div class="details-table-table-row text-center" style="min-width: 45px">
                                    {{listsIndex + 1}}
                                </div>
                            </div>
                            <template v-for="(list, index) in config.list">
                                <table-col :key="listsIndex + '-' + index" v-if="list.per !== 3">
                                    <div class="details-table-table-row details-width"
                                        style="white-space: inherit;word-break: break-all;"
                                        :style="'width:' + (!widthObj[list.title + '_' + list.type] ? !list.width ? '180px;' : list.width : widthObj[list.title + '_' + list.type])"
                                    >
                                    <template v-if="list.type === 'image'">
                                        <div>
                                            <el-image v-for="(img, imgIndex) in getTitleValue(list, lists)" :key="imgIndex" :src="img.url" fit="contain" style="max-width:80px;max-height:80px;" />
                                        </div>
                                    </template>
                                    <template v-else-if="list.type !== 'relation-user' || typeof getTitleValue(list, lists) === 'string'">
                                        {{ getTitleValue(list, lists) }}
                                    </template>
                                    <template v-else>
                                        <span class="relationUserStyle"
                                            v-for="relU in getTitleValue(list, lists) || []"
                                            :key="relU.organizationId"
                                        >{{relU.realname}}</span>
                                    </template>
                                </div>
                                </table-col>
                            </template>
                        </div>
                    </template>
                </template>
        </el-scrollbar>

    </div>
</template>

<script>
    import tableHeaderCol from "./table-header-col.vue";
    import tableCol from "./table-col.vue";
    
    export default {
        name: 'tableRead',
        components: {
            tableHeaderCol,
            tableCol
        },
        props: {
            config: {
                type: Object,
                default: () => {
                    return { list: [] }
                }
            },
            formdata: {
                type: Object,
                default: () => {
                    return {
                        top: [],
                        data: []
                    }
                }
            }
        },
        data () {
            return {
                widthObj: {}, // 宽度列表
                tableWidth: 0,
                tableCellWidth: 0,
                topDistance: 0, // 顶部距离
                myObserver: null,  // 监听大小变化
            }
        },
        mounted() {
            this.getSys()
            this.myObserver = new ResizeObserver(entries => {
                entries.forEach(entry => {
                    const width = entry.contentRect.width
                    if (!this.tableCellWidth || (this.tableCellWidth - 5) < width < (this.tableCellWidth + 5)) {
                    this.getHeaderWidth()
                    }
                })
            })
        },
        methods: {
            getTitleValue (config, value) {
                const { top } = this.formdata
                if (this.config.type === 'relation-check') {
                    let ctop = top.find(i => i.title === config.title)
                    if (ctop) {
                        return this.getResValue(config, value)
                    } else {
                        ctop = top.find(i => i.name === config.name)
                        if (ctop) {
                            return value[ctop.title]
                        }
                    }
                } else {
                    return this.getResValue(config, value)
                }
            },
            getResValue (config, value) {
                for (const i of this.formdata.top) {
                    if (i.title === config.title || config.field === i.title) {
                        return value[config.title || config.field]
                    }
                }
                return value[config.title]  
            },
            // 获取dom基础信息
            async getSys () {
                await this.$nextTick()
                const id = this.config.title + "_" + "3";
                const dom = this.$refs[id];
                if (dom) {
                    const domHeader = dom.getElementsByClassName('header')
                    if (domHeader && domHeader[0]) {
                    const tableWidth = domHeader[0].scrollWidth || domHeader[0].cellWidth;
                    const tableCellWidth = dom.offsetWidth;
                    if (tableCellWidth < tableWidth) {
                        // dom.removeEventListener("scroll", this.distanceFun);
                        // dom.addEventListener("scroll", this.distanceFun, 1000);
                    }
                    this.tableWidth = tableWidth
                    this.tableCellWidth = tableCellWidth
                    }
                }
            },
            getHeaderWidth () {
                const id = this.config.title + "_" + "3";
                const dom = this.$refs[id];
                const domHeader = document.getElementsByClassName('header')
                const tableCellWidth = dom.offsetWidth;
                if (domHeader && domHeader[0]) {
                    const tableWidth = domHeader[0].scrollWidth || domHeader[0].cellWidth;
                    this.tableWidth = tableWidth
                    this.tableCellWidth = tableCellWidth
                }
            },
            addMousedown(event, type) {
                const self = this;
                const target = event.target || event.srcElement;
                const parentDom = target.parentNode;
                const width = parentDom.clientWidth;

                document.onmousemove = function(move) {
                    // 拖拽对象的坐标 = 鼠标的坐标(event.client) - 拖拽对象的大小(dis)
                    const widthNumber = move.clientX - event.clientX;
                    const widthVal = Number(width) + Number(widthNumber);

                    if (widthVal > 89 && widthVal < 721) {
                    const str = "min-width:" + widthVal + "px;width:" + widthVal + "px;";
                    (
                        target.previousElementSibling || target.previousSibling
                    ).style.cssText = str;
                    self.$set(self.widthObj, type, widthVal + "px");
                    }
                };
                // 当鼠标放开时执行的js
                document.onmouseup = function() {
                    document.onmousemove = null;
                    document.onmouseup = null;
                };
                // 右键点击检测
                document.onmousedown = function(e) {
                    if (e.which == 3) {
                    document.onmousemove = null;
                    document.onmouseup = null;
                    }
                };
            },
            // 放开
            mouseOpen (e) {
                e.stopPropagation()
                this.distanceFun(e)
                this.isMouseup = false
                document.removeEventListener('mouseup', this.mouseOpen)
            },
            // 横向滚动触发
            distanceFun(e) {
                // 监听鼠标放开事件做一次兼容
                if (!this.isMouseup) {
                    document.addEventListener("mouseup", this.mouseOpen)
                    this.isMouseup = true
                }
                this.topDistance = e.target.scrollLeft;
            },

        },
        beforeUnmount() {
            const id = this.config.title + "_" + "3";
            const dom = document.getElementById(id);
            if (dom) {
                const self = this;
                dom.removeEventListener("scroll", self.distanceFun);
            }
            if (this.myObserver) this.myObserver = null
        },

    }
</script>

<style scoped lang="scss">
.details-table-all-1 {
    position: relative;
    border: 1px solid #e5e5e5;
    border-radius: 10px;
    overflow-y: hidden;
    overflow-x: auto;
    -webkit-overflow-scrolling:touch;
    .header .details-table-row {
        background-color: #f7f7f7;
        color: #333333;
        font-weight: bold;
    }
    .details-table-row {
        display: table-cell;
        table-layout: fixed;
        border-right: 1px solid #e5e5e5;
        border-bottom: 1px solid #e5e5e5;
        font-size: 14px;
        color: rgba(51, 51, 51, 1);
        flex: 1;
        vertical-align: middle;
        background-color: #ffffff;
        position: relative;
    }
    .table-col-nowrap {
        white-space: nowrap;
    }
    .details-table-header-row {
        padding: 10px;
        display: flex;
    }
    .cor-red {
        color: red;
        margin-right: 2px;
    }
    .one-omit {
        width: 100%;
        flex-wrap: wrap;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
    .table-mouse {
        position: absolute;
        right: 0;
        top: 0;
        height: 100%;
        border-right: 2px solid transparent;
        cursor: col-resize;
    }
    .details-table-no-text {
        padding-top: 28px;
        color: #999999;
        position: relative;
        height: 20px;
        padding-bottom: 10px;
    }
    .details-table-no-text div {
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
    }
    .details-table-col {
        display: table-row;
        border-bottom: 1px solid #e5e5e5;
        position: relative;
    }
    .details-table-table-row {
        padding: 5px 10px;
        white-space: inherit;
        word-break: break-all;
        line-height: 1.3;
    }
    .text-center {
        text-align: center;
    }

}

</style>